import { Type } from "@themes/pollinator/ui/Type";
import { type DonutChartDataItem } from "@themes/pollinator/ui/DonutChart";
import { TrackingMetricItem } from "./TrackingMetricItem";

/** Input data shape - color is optional, will be assigned if missing */
type SignupMethodInput = {
  value: number;
  label: string;
  color?: string;
};

export type Props = {
  claimedSeats: number;
  totalSeats: number;
  signupMethodData: SignupMethodInput[];
  /** Optional breakdown by invitation (shown when > 1 invitations) */
  invitationBreakdownData?: SignupMethodInput[];
};

const SIGNUP_METHOD_COLORS = ["brand-700", "brand-600", "brand-400"];
const INVITATION_BREAKDOWN_COLORS = ["brand-500", "brand-400", "brand-300", "brand-600"];

export function TrackingMetrics({
  claimedSeats,
  totalSeats,
  signupMethodData,
  invitationBreakdownData,
}: Props) {
  const signupMethodDataWithColors: DonutChartDataItem[] = signupMethodData.map(
    (item, i) => ({
      ...item,
      color: item.color || SIGNUP_METHOD_COLORS[i % SIGNUP_METHOD_COLORS.length],
    })
  );

  const invitationBreakdownDataWithColors: DonutChartDataItem[] | undefined =
    invitationBreakdownData?.map((item, i) => ({
      ...item,
      color:
        item.color ||
        INVITATION_BREAKDOWN_COLORS[i % INVITATION_BREAKDOWN_COLORS.length],
    }));

  const seatPercentage =
    totalSeats > 0 ? Math.floor((claimedSeats / totalSeats) * 100) : 0;

  return (
    <div className="flex flex-col gap-12 md:flex-row md:gap-24">
      <TrackingMetricItem
        title="Seats Claimed"
        data={[{ value: seatPercentage, label: "Claimed", color: "brand-500" }]}
        showLegend={false}
        showPercentage={false}
        showCenterLabel
        isPercentageMeter
      >
        <div className="flex flex-col items-center">
          <Type variant="h3" as="span">
            {claimedSeats}
          </Type>
          <Type variant="body2">out of {totalSeats}</Type>
        </div>
      </TrackingMetricItem>
      <TrackingMetricItem
        title="Signup Method"
        data={signupMethodDataWithColors}
        showLegend
        showPercentage
        showCenterLabel={false}
        isPercentageMeter={false}
      />
      {invitationBreakdownDataWithColors &&
        invitationBreakdownDataWithColors.length > 0 && (
          <TrackingMetricItem
            title="By Invitation"
            data={invitationBreakdownDataWithColors}
            showLegend
            showPercentage
            showCenterLabel={false}
            isPercentageMeter={false}
          />
        )}
    </div>
  );
}

export default TrackingMetrics;

